<div class="modal-header">
  <h2 class="modal-title">Exporter le calcul</h2>
</div>
<div class="modal-body flex-column">

  @if (this.exportState === 'REFRESHING' || this.exportState === 'LOADING') {
    <div class="alert alert-primary">
      <span aria-hidden="true" class="spinner-border spinner-border-sm me-3" role="status"></span> Export du calcul en
      cours...
    </div>
  }

  @if (this.error) {
    <div class="alert alert-danger">
      {{ this.error }}
    </div>
  }

  <p>Optitax vous permet d'exporter facilement votre calcul.</p>

  <h3>Format</h3>
  <div class="d-flex gap-2 flex-column">

    <label for="btn-file">
      <input [formControl]="formControl" [value]="ExportType.Optitax" autocomplete="off"
        class="btn-check card-input-element" id="btn-file"
        name="btnradio" type="radio">
      <div class="card card-input mb-3">
        <div class="row g-0">
          <div class="col-md-2 col-lg-1 d-flex align-items-center justify-content-center">
            <span> <i class="fas fa-check-circle"></i> </span>
          </div>
          <div class="col-md-10 col-lg-11">
            <div class="card-body">
              <h5 class="card-title"><strong> <span class="text-primary"><i
              class="far fa-file"></i></span> Optitax (.optitax) </strong>
            </h5>
            <p class="card-text">Le fichier .optitax vous permet de conserver une copie locale du calcul
            pour vos dossiers.</p>

          </div>
        </div>
      </div>
    </div>
  </label>
  <label for="btn-excel">
    <input [formControl]="formControl" [value]="ExportType.XLSX" autocomplete="off"
      class="btn-check card-input-element" id="btn-excel"
      name="btnradio" type="radio">
    <div class="card card-input mb-3">
      <div class="row g-0">
        <div class="col-md-2 col-lg-1 d-flex align-items-center justify-content-center">
          <span> <i class="fas fa-check-circle"></i> </span>
        </div>
        <div class="col-md-10 col-lg-11">
          <div class="card-body">
            <h5 class="card-title"><strong> <span class="text-success"><i
            class="far fa-file-excel"></i></span>
            Excel
          (.xlsx) </strong>
        </h5>
        <p class="card-text">L'export en format Excel (.xlsx) vous permet d'ouvrir et visualiser le
        calcul dans Excel.</p>

      </div>
    </div>
  </div>
</div>
</label>


<!--        <div>-->
<!--            <input type="radio" class="btn-check" name="btnradio" id="btn-pdf" autocomplete="off"  [formControl]="formControl" [value]="ExportType.PDF">-->
<!--            <label class="btn btn-outline-primary" for="btn-pdf"><i class="far fa-file-pdf"></i> PDF (.pdf)</label>-->
<!--        </div>-->
</div>


</div>
<div class="modal-footer">
  <button (click)="close()" class="btn btn-light" type="button">Fermer</button>
  <button (click)="export()" [disabled]="this.exportState === 'REFRESHING' || this.exportState === 'LOADING'"
    class="btn btn-primary"
    role="button">
    @if (this.exportState === 'REFRESHING' || this.exportState === 'LOADING') {
      <span aria-hidden="true"
        class="spinner-border spinner-border-sm me-3"
      role="status"></span>
    }
    @if (this.exportState === 'READY' || this.exportState === 'ERROR') {
      <span>Exporter le calcul</span>
    }
    @if (this.exportState === 'REFRESHING' || this.exportState === 'LOADING') {
      <span>Export en cours...</span>
    }
  </button>
</div>
